import { api } from '..';

export function getImageByCategory(payload) {
  return api('GET', `/panel/images/${payload.category}`, payload);
}

/**
 *
 * @param { String } category - [avatar, exhibition, staticArtworkOriginal, staticArtworkPreview, videoArtworkPreview, websiteArtworkPreview, modelArtworkPreview, musicArtworkPreview, wallVision, keyVision, seo]
 * @returns
 */
export function addImageByCategory({ category, data }) {
  return api('UPLOAD', `/panel/images/${category}`, data);
}

export function getExhibitionScenes(payload) {
  return api('GET', `/panel/exhibition-scenes`, payload);
}
